import React, { memo } from 'react';
import * as PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import InsuranceForm from '../../../forms/InsuranceForm';

import { INSURANCE_FLOW_TYPE } from '../../../../constants/insurance-flow-type';

import { targetUserIdSelector } from '../../../../redux/context/selectors';

function InsuranceDetailsForm({
  targetUserName,
  flowType,
  insuranceData,
  cancel,
}) {
  const userId = useSelector(targetUserIdSelector);

  return (
    <section>
      <InsuranceForm
        userId={userId}
        userName={targetUserName}
        flowType={flowType}
        insuranceData={insuranceData}
        cancel={cancel}
        withPlanNotListedOption={false}
      />
    </section>
  );
}

InsuranceDetailsForm.propTypes = {
  cancel: PropTypes.func,
  flowType: PropTypes.oneOf(Object.keys(INSURANCE_FLOW_TYPE)),
  insuranceData: PropTypes.object,
  targetUserName: PropTypes.string,
};

export default memo(InsuranceDetailsForm);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/InsuranceDetailsForm/index.jsx